import { twMerge } from 'tailwind-merge';

import { USStateObject } from '@domain/states/types';
import { getRegionUrl, getSpeciesGroupRegionUrl } from '@domain/routes/urls';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { Text } from '../../Text/Text';
import { IStateDataObjectSpecies } from '../helpers/buildStateDataSpecies';

interface IProps {
  selectedState: USStateObject;
  stateSpeciesGroups: IStateDataObjectSpecies[];
  className: string;
}

/*
NB: These species groups are still hard coded. We might want to fetch them from the backend later on!
*/
export const SpeciesGroupLinks = ({ selectedState, className, stateSpeciesGroups }: IProps) => {
  const countryId = 'US';
  const countryName = 'United States';
  const titleText = `Most popular species in ${selectedState.stateName}`;
  const buttonText = `Explore ${selectedState.stateName}`;

  return (
    <div className={twMerge('mx-auto w-full flex-col gap-y-3 sm:w-1/2', className)}>
      <Text variant="sm" className="mb-0">
        {titleText}
      </Text>

      <div className="flex flex-col gap-y-3">
        {stateSpeciesGroups.flatMap(speciesGroup => {
          const { externalId, name } = speciesGroup;
          if (!externalId || !name) {
            return [];
          }
          return (
            <InternalLink
              to={getSpeciesGroupRegionUrl(countryId, selectedState.stateID, externalId)}
              key={externalId}
            >
              <Text variant="md" className="mb-0 py-1">
                {name} fishing in {selectedState.stateName}
                <ArrowRightIcon size={18} className="ml-1" />
              </Text>
            </InternalLink>
          );
        })}
      </div>
      <div className="flex w-full justify-center sm:justify-start">
        <InternalLink
          to={getRegionUrl(countryId, selectedState.stateID, countryName, selectedState.stateName)}
          variant="buttonSecondary"
        >
          {buttonText}
        </InternalLink>
      </div>
    </div>
  );
};
